export default function createTimePickerPalette(theme, current, base) {
    return {
        timePicker: {
            invalid: {
                color: base.gray[400],
            },
        },
    };
}
//# sourceMappingURL=time-picker.js.map